import React from 'react'
import {useInjection} from 'dna-react-ioc'
import {ErrorBoundary} from '../ErrorBoundary'
import {IErrorBoundaryStore} from '@/components/containers/ErrorBoundary/IErrorBoundaryStore'

export const ErrorBoundaryStoreSymbol = Symbol('ErrorBoundaryStore')

export const ErrorBoundaryWrapper = ({ children }) => {
    const errorBoundaryStore = useInjection<IErrorBoundaryStore>(ErrorBoundaryStoreSymbol)

    return <ErrorBoundary errorBoundaryStore={errorBoundaryStore}>{children}</ErrorBoundary>
}
